const UNITS = [
  ['year', 365 * 24 * 3600],
  ['month', 30 * 24 * 3600],
  ['week', 7 * 24 * 3600],
  ['day', 24 * 3600],
  ['hour', 3600],
  ['minute', 60],
];
const format = new Intl.RelativeTimeFormat('en', { numeric: 'auto', style: 'short' });

// "5 min. ago", "yesterday", "3 wk. ago"; '' for missing/invalid dates.
export function timeAgo(value) {
  const time = value ? new Date(value).getTime() : NaN;
  if (Number.isNaN(time)) return '';
  const seconds = Math.round((time - Date.now()) / 1000);
  for (const [unit, size] of UNITS) {
    if (Math.abs(seconds) >= size) return format.format(Math.round(seconds / size), unit);
  }
  return 'just now';
}
